var installedModules = {};
var moduleToHandlerMapping = {
	60831: {
		getter: () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__(63696))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.14.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	61471: {
		getter: () => (__webpack_require__.e(8325).then(() => (() => (__webpack_require__(78325))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.14.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	65811: {
		getter: () => (Promise.all([__webpack_require__.e(5404), __webpack_require__.e(1747)]).then(() => (() => (__webpack_require__(55404))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~2.4.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-intl",
	},
	12218: {
		getter: () => (Promise.all([__webpack_require__.e(6831), __webpack_require__.e(1738)]).then(() => (() => (__webpack_require__(42689))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.29.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "moment",
	},
	72320: {
		getter: () => (__webpack_require__.e(1198).then(() => (() => (__webpack_require__(41198))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.4.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "reflux",
	},
	20289: {
		getter: () => (__webpack_require__.e(7243).then(() => (() => (__webpack_require__(17243))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.17.21",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	23725: {
		getter: () => (__webpack_require__.e(5215).then(() => (() => (__webpack_require__(65215))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.2.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	},
	58783: {
		getter: () => (__webpack_require__.e(6518).then(() => (() => (__webpack_require__(54137))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.23.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-bootstrap",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"181": [
		58783
	],
	"289": [
		20289
	],
	"831": [
		60831
	],
	"2218": [
		12218
	],
	"3175": [
		72320
	],
	"5330": [
		23725
	],
	"6159": [
		61471,
		65811
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}